import { IActiveUserRegistrationData, IAuthData } from "./interface";

export const isUserAuthenticatedSelector = (state: any): boolean => {
  return state?.auth?.isAuthenticated || false;
};

export const getAuthSessionTokenSelector = (state: any): string => {
  return state?.auth?.authData?.sessionToken || "";
};

export const isUserLoginLoaderSelector = (state: any): boolean =>
  state?.auth?.loaders?.login;
export const userLoginErrorSelector = (state: any): string =>
  state.auth.errors.login ?? "";

export const getActiveUserRegistrationDataSelector = (
  state: any
): IActiveUserRegistrationData => {
  return state?.auth?.activeUserRegistrationData || {};
};
export const getRegisterUserLoaderSelector = (state: any): boolean => {
  return state?.auth?.loaders?.registerUser ?? false;
};
export const getRegisterUserErroSelector = (state: any): string => {
  return state?.auth?.errors?.registerUser?.errorMessage ?? "";
};

export const getRegisterUserErrorCodeSelector = (state: any): string => {
  return state?.auth?.errors?.registerUser?.errorCode ?? "";
};

export const getAuthDataSelector = (state: any): IAuthData => {
  return state?.auth?.authData ?? null;
};
